import { render, staticRenderFns } from "./currencyDetail2.vue?vue&type=template&id=4797675d&"
import script from "./currencyDetail2.vue?vue&type=script&lang=js&"
export * from "./currencyDetail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4797675d')) {
      api.createRecord('4797675d', component.options)
    } else {
      api.reload('4797675d', component.options)
    }
    module.hot.accept("./currencyDetail2.vue?vue&type=template&id=4797675d&", function () {
      api.rerender('4797675d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/currencyDetail2.vue"
export default component.exports